import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
/**
 * Created by karthikeyan.k on 13-11-2018.
 */

export function createTranslateLoader() {
  const http = inject(HttpClient);
  return new TranslateHttpLoader(
    http,
    './assets/i18n/',
    '.json?t=' + Date.now()
  );
}
